import React from "react";
import { gql } from "apollo-boost";
import { graphql, compose } from "react-apollo";
import { Route, Switch } from "react-router-dom";
import { Flex, Box } from "grid-styled";
import { Helmet } from "react-helmet";
import { H1 } from "./Heading";
import Button, { LinkButton } from "./Button";
import join from "../utils/join-path";
import { TabBar, TabLink } from "./tabs";
import CenteredLoader from "./CenteredLoader";
import FranchiseDetails from "./FranchiseDetails";
import FranchiseStaff from "./FranchiseStaff";

const FranchiseHeader = ({ franchise, toggleActive }) => (
  <Flex justify="space-between">
    <Box>
      <H1>{franchise.name}</H1>
    </Box>
    <Box>
      <LinkButton to={`/${franchise.slug}`} style={{ marginRight: 4 }}>
        Visit Franchise Panel
      </LinkButton>
      <Button
        variant={franchise.deactivated ? "primary" : "danger"}
        onClick={toggleActive}
      >
        {franchise.deactivated ? "Activate" : "Deactivate"} Franchise
      </Button>
    </Box>
  </Flex>
);

class Franchise extends React.Component {
  render() {
    const { match, data: { loading, error, franchise } } = this.props;

    if (loading) return <CenteredLoader />;
    if (error) return "Error.";

    return (
      <Box p={3}>
        <Helmet>
          <title>{franchise.name}</title>
        </Helmet>
        <FranchiseHeader
          franchise={franchise}
          toggleActive={
            franchise.deactivated
              ? this.props.activateFranchise
              : this.props.deactivateFranchise
          }
        />
        <TabBar bordered>
          <TabLink exact to={match.url}>
            General
          </TabLink>
          <TabLink to={join(match.url, "/staff")}>Staff</TabLink>
        </TabBar>
        <Switch>
          <Route exact path={match.path} component={FranchiseDetails} />
          <Route
            path={`${match.path}/staff`}
            render={({ match }) => (
              <FranchiseStaff franchiseId={match.params.franchiseId} />
            )}
          />
        </Switch>
      </Box>
    );
  }
}

const FRANCHISE_QUERY = gql`
  query FranchiseQuery($id: ID!) {
    franchise(id: $id) {
      id
      name
      slug
      deactivated
    }
  }
`;

const deactivateFranchise = gql`
  mutation DeactivateFranchise($id: ID!) {
    deactivateFranchise(id: $id) {
      id
      name
      slug
      deactivated
    }
  }
`;

const activateFranchise = gql`
  mutation ActivateFranchise($id: ID!) {
    activateFranchise(id: $id) {
      id
      name
      slug
      deactivated
    }
  }
`;

const enhance = compose(
  graphql(FRANCHISE_QUERY, {
    options: ({ match: { params: { franchiseId } } }) => ({
      variables: { id: franchiseId }
    })
  }),
  graphql(deactivateFranchise, {
    props({ ownProps: { match: { params: { franchiseId } } }, mutate }) {
      return {
        deactivateFranchise() {
          return mutate({
            variables: { id: franchiseId }
          });
        }
      };
    }
  }),
  graphql(activateFranchise, {
    props({ ownProps: { match: { params: { franchiseId } } }, mutate }) {
      return {
        activateFranchise() {
          return mutate({
            variables: { id: franchiseId }
          });
        }
      };
    }
  })
);

export default enhance(Franchise);



// WEBPACK FOOTER //
// ./src/components/Franchise.js